/*
Sohel  12/19/2022 3075154998 data manager Ux Changes
Sohel 01/09/2023 3075154998 change routes
Sohel 01/10/2023 3075154998 fixed route issue
Akhila 06/12/2023 3075154998 added role access
Phanee 08/03/2023 3075154998 Fixed dashboard data disable issue
*/
import React, {useState, useContext, useEffect} from 'react';
import LandingPage from '../../../../Pages/LandingPage';
import SearchDataManager from './SearchDataManager';
import AddDataManager from './AddDataManager';
import {ThemeContext} from '../../../../themes/ThemeProvider';
import {useLocation} from 'react-router-dom';
import {useSelector} from 'react-redux';
import {EXPORT_DATA, IMPORT_DATA} from '../../../../constants/ReusableRoleAccess';
function DataManager() {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const [value, setValue] = useState(0);

  const location = useLocation();
  const exportManager = location.pathname === '/frameworks/export-manager' ? true : false;
  const tabLabels = exportManager ? ['Export Manager'] : ['Import Manager'];
  const [editExisting, setEditExisting] = useState(false);
  const {roleData} = useSelector(({role}) => role);
  const DataManagerAccess = exportManager ?
    roleData?.window?.[EXPORT_DATA]?.['EM'] :
    roleData?.window?.[IMPORT_DATA]?.['IM'];

  useEffect(() => {
    setValue(0);
  }, [exportManager]);
  return (
    <>
      <LandingPage
        title={'Data Management'}
        showTabs={true}
        tabValue={0}
        handleTabChange={()=>{}}
        allAntTabs={tabLabels}
      >
        <div className="global-field-dash-board">
          <div className={` ${classes.cardStyleWhite}`}>
            { exportManager && (
              <h2 className="search-title">Export Manager Search</h2>
            )}
            { !exportManager && (
              <h2 className="search-title">Import Manager Search</h2>
            )}
            <div className={classes.root}>
              <div className={classes.subContent}>
                {value === 0 && (
                  <SearchDataManager
                    setValue={setValue}
                    exportManager={exportManager}
                    setEditExisting={setEditExisting}
                    DataManagerAccess={DataManagerAccess}
                  />
                )}
                {value === 1 && (
                  <AddDataManager
                    editExisting={editExisting}
                    setValue={setValue}
                    exportManager={exportManager}
                    DataManagerAccess={DataManagerAccess}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </LandingPage>
    </>
  );
}

export default DataManager;
